export default "__VITE_ASSET__CsdA_QxE__"